<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-04-26 15:15:24
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-04-26 17:20:41
-->
<template>
	<div class="component">
		<p class="label">
			{{ question.name }}
			<span v-if="question.mustAnswer" class="required">*</span>
		</p>
		<div
			v-for="(option, index) in question.optionList"
			:key="option.id"
			:class="question.optionList.length > 1 && question.optionList.length - 1 > index ? 'm-b-5' : ''"
		>
			<div class="input_label">{{option.name}}</div>
			<van-field
				@input="change"
				style="background:#ffffff"
				:disabled="disabled"
				placeholder="请输入"
				v-model="option.value"
				:type="option.type||''"
				:rules="rule"
				:maxlength="question.verifyMax"
			>
				<template slot="extra"> {{ option.suffixName }} </template>
				<template #button v-if="option.tag">
					<van-tag
						round
						class="tag_row"
						:color="option.tag(option.value).color "
						v-if="option.tag(option.value).text"
						>{{ option.tag(option.value).text }}</van-tag
					>
				</template>
			</van-field>
		</div>

		<g-question-description v-model="show" :list="list" />
	</div>
</template>

<script>
import GQuestionDescription from "./GQuestionDescription.vue";
export default {
    name: 'GField',
    components: { GQuestionDescription },
    props: ['question', 'value', 'option', 'rule', 'disabled'],
    model: {
        prop: 'value',
        event: 'customInput'
    },
    computed: {
        list () {
            return this.question.remark.split('\n')
        }
    },
    data () {
        return {
            show: false
        }
    },
    methods: {
        change () {
            this.$emit('change')
        }
    }
}
</script>

<style lang="less" scoped>
@import './base.less';
.component {
	.van-cell {
		padding: 28px;
		border-radius: 16px;
		overflow: hidden;
		font-size: 32px;
	}
	.input_label {
		color: @gray-9;
		font-size: 26px;
		margin-bottom: 12px;
	}
	.m-b-5 {
		margin-bottom: 32px;
	}
	.tag_row {
		height: 40px;
		font-size: 24px;
		border-radius: 20px;
		padding: 0 16px;
	}
}
</style>
